import {Directive, Inject, Input} from '@angular/core';
import {MAT_DATE_RANGE_SELECTION_STRATEGY} from "@angular/material/datepicker";
import {HunaDateStrategyService} from "../service/huna-date-strategy.service";

@Directive({
    selector: '[appRangeDate]',
    providers: [
        {
            provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
            useClass: HunaDateStrategyService
        }
    ],
    standalone: false
})
export class RangeDateDirective {

    constructor(
        @Inject(MAT_DATE_RANGE_SELECTION_STRATEGY)
        private maxRangeStrategy: HunaDateStrategyService
    ) {
    }

    @Input() set maxRange(value: number | undefined) {
        this.maxRangeStrategy.delta = (value != null) ? +value : 7;
    }

}
